/**
 * @package admin
 */

import EntityCollection from '@shopware-ag/admin-extension-sdk/es/data/_internals/EntityCollection';

// eslint-disable-next-line sw-deprecation-rules/private-feature-declarations
export default EntityCollection;
